import React, {useEffect, useState} from "react";
import Fab from '@mui/material/Fab';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { makeStyles } from "@material-ui/styles";
const useStyles = makeStyles((theme) => ({
    
    scrollButton: {
        position: "fixed",
        // bottom: "100vh",
        // width: "100%"
        top:"calc(100vh - 100px)",
        left:"calc(1024px + calc(calc(100vw - 1280px) / 2))",
        [theme.breakpoints.down('md')]: {
            top:"calc(100vh - 100px)",
            left:"calc(100vw - 100px)",
        
          },
      }, 
}))
const ScrollButton = () => {
    const classes = useStyles();
    const [showScroll, setShowScroll] = useState(false);

    const checkScrollTop = () => {
        if (!showScroll && window.pageYOffset > 400){
        setShowScroll(true);
        } else if (showScroll && window.pageYOffset <= 400){
        setShowScroll(false);
        }
    };
    const scrollTop = () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
      };
    useEffect(() => {
        window.addEventListener('scroll', checkScrollTop);
        return () => {
          window.removeEventListener('scroll', checkScrollTop);
        };
    }, [showScroll]);
  return (
    <>
        {showScroll &&
            <div className = {classes.scrollButton}>
                <Fab 
                    color="primary" 
                    size="small" 
                    onClick={scrollTop} 
                    // className={classes.scrollButton}
                >
                    <KeyboardArrowUpIcon />
                </Fab>
            </div>
        }
    </>
  )
}

export default ScrollButton